<div class="module-grid">
  <div class="module-card" (click)="irAModulo('pedidos')">
    <div class="module-icon">
      <mat-icon>receipt_long</mat-icon>
    </div>
    <h3 class="module-title">Pedidos</h3>
    <p class="module-desc">Administrar pedidos.</p>
  </div>

  <div class="module-card" (click)="irAModulo('parametros')">
    <div class="module-icon">
      <mat-icon outline>settings_applications</mat-icon>
    </div>
    <h3 class="module-title">Parámetros</h3>
    <p class="module-desc">Administrar parámetros del sistema.</p>
  </div>

  <div class="module-card" (click)="irAModulo('productos')">
    <div class="module-icon">
      <mat-icon>fastfood</mat-icon>
    </div>
    <h3 class="module-title">Productos</h3>
    <p class="module-desc">Gestión de productos a la venta.</p>
  </div>

  <!-- <div class="module-card" (click)="irAModulo('calendario')">
    <div class="module-icon">
      <mat-icon>today</mat-icon>
    </div>
    <h3 class="module-title">Calendario</h3>
    <p class="module-desc">Visualizador de pedidos por hora.</p>
  </div> -->
</div>
